import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { authGuard } from './common/guard/auth.guard';
import { AdminComponent } from './features/admin/ui/pages/admin.component';
import { DashboardComponent } from './features/admin/ui/pages/dashboard/dashboard.component';
import { ConvertedFilesComponent } from './features/admin/ui/pages/converted-files/converted-files.component';
import { UsersComponent } from './features/admin/ui/pages/users/users.component';
import { UserDetailsComponent } from './features/admin/ui/pages/user-details/user-details.component';
import { CompaniesComponent } from './features/admin/ui/pages/companies/companies.component';
import { CompanyDetailsComponent } from './features/admin/ui/pages/company-details/company-details.component';
import { LoginComponent } from './features/login/ui/pages/login/login.component';
import { LoginCallbackComponent } from './features/login/ui/pages/login-callback/login-callback.component';
import { NoAccessComponent } from './features/login/ui/pages/no-access/no-access.component';
import { HomeComponent } from './features/home/ui/pages/home.component';

const adminChildren: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'converted-files', component: ConvertedFilesComponent },
  { path: 'users', component: UsersComponent },
  { path: 'users/details/:id', component: UserDetailsComponent },
];

if (environment.isSuperAdmin) {
  adminChildren.push(
    { path: 'companies', component: CompaniesComponent },
    { path: 'companies/:id', component: CompanyDetailsComponent },
  );
}

const baseRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login-callback', component: LoginCallbackComponent },
  { path: 'no-access', component: NoAccessComponent },
];

const homeOrRootRedirect: Routes = environment.isSuperAdmin
  ? [{ path: '', redirectTo: 'admin/dashboard', pathMatch: 'full' }]
  : [{ path: '', component: HomeComponent, canActivate: [authGuard] }];

export const appRoutes: Routes = [
  ...baseRoutes,
  ...homeOrRootRedirect,
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [authGuard],
    children: [
      ...adminChildren,
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
